export enum ChainId {
  MAINNET = 56,
  TESTNET = 97
}

// Используем PancakeSwap V2 (рабочие контракты)
export const FACTORY_ADDRESS = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';
export const ROUTER_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E';

// BSC Mainnet Tokens
export const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';
export const BUSD_ADDRESS = '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56';
export const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

// PUZO Token Address
export const PUZO_ADDRESS = '0x74fAa551b7eEE70a19aE8D5657d314Dad0bcdB93';

// Network Configuration
export const BSC_MAINNET = {
  chainId: '0x38',
  chainName: 'Binance Smart Chain Mainnet',
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
  },
  rpcUrls: ['https://bsc-dataseed.binance.org/'],
  blockExplorerUrls: ['https://bscscan.com/'],
};

export const SUPPORTED_CHAINS = [56];
export const isPuzoConfigured = (): boolean => true;
